import Vue from 'vue';
import getSerialisedParams from '../../utils/getSerialisedParams.js';
import BaseCount from '../../mixins/BaseCount/BaseCount.js';
import JSONP from '../../utils/jsonp.js';

/**
 * Hey!
 *
 * STumblrCount component used for Tumblr social network
 * @link https://tumblr.com/
 */
/**
 * Share parameters for link
 * @link https://www.tumblr.com/docs/en/share_button
 */

var STumblrCount = /* #__PURE__ */Vue.extend({
  name: 'STumblrCount',
  mixins: [BaseCount('Tumblr')],
  methods: {
    handleTumblrResponse: function handleTumblrResponse(data) {
      var _data$response;

      this.handleResult(data);
      this.handleCount((_data$response = data.response) === null || _data$response === void 0 ? void 0 : _data$response.note_count);
    }
  },
  mounted: function mounted() {
    var _this = this;

    var shareOptions = this.shareOptions;
    var url = shareOptions.url;
    var BASE_URL = 'http://api.tumblr.com/v2/share/stats';
    var finalURL = "".concat(BASE_URL).concat(getSerialisedParams({
      url: url
    }));
    this.handleLoading(true);
    JSONP(finalURL, function (err, data) {
      _this.handleLoading(false);

      if (err) {
        _this.handleError(err);
      }

      if (data) {
        _this.handleTumblrResponse(data);
      }
    });
  }
});

export default STumblrCount;
